module.exports = __webpack_public_path__ + "static/media/Sales and Customer-Facing Roles.d021945c.png";